
import React from 'react'
import { useState } from 'react';
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'

const OrderTransactionDetails = () => {

    const orlineId = localStorage.getItem("ditsCurrentOrderLineId");
    const { data, error, isLoaded } = GetRequest(`/Orders/GetOrderLineSummary/${orlineId}`);
    if (error !== null) {
        return <Error data=" " />;
    }
    if (!isLoaded) {
        return <Loading />;
    } else {
        localStorage.removeItem('OredrCartProductData');
    }

    const handleUPIPayment1 = () => {
        window.location.href = "intent://pay?pa=9860366327@ybl&pn=FNAME SNAME K&mc=12524262&tid=9876543210&tr=1234567890&tn=Payment&am=100&cu=INR&url=https://yourwebsite.com#Intent;scheme=upi;package=com.phonepe.app;end;";
    };

    const handleUPIPayment2 = () => {
        try {
            window.location.href = "intent://pay?pa=9860366327@ybl&pn=FNAME SNAME K&mc=12524262&tid=9876543210&tr=1234567890&tn=Payment&am=100&cu=INR&url=https://yourwebsite.com#Intent;scheme=upi;package=com.phonepe.app;end;";

            setTimeout(() => {
                // Redirect to Play Store if PhonePe is not installed
                window.location.href = "https://play.google.com/store/apps/details?id=com.phonepe.app";
            }, 3000); // Wait 3 seconds before redirecting
        } catch (error) {
            console.error("Error launching UPI app:", error);
        }
    };

    const handleUPIPayment3 = () => {
        window.location.href = "upi://pay?pa=9860366327@ybl&pn=FNAME SNAME K&mc=12524262&tid=9876543210&tr=1234567890&tn=Payment&am=100&cu=INR";
    };

    const handleInitiatePayment = async () => {
        const requestBody = {
            amount: 1,
            firstName: "Uday",
            email: "udkadam@gmail.com",
            phoneNumber: "9284773653",
            productInfo: "Order #" + data.result.orderNumber
        };

        try {
            const response = await fetch("https://ecomplatformapi.erelatelabs.com/api/Product/InitiatePaymentHostedCheckOut", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            const result = await response.json();

            if (result.result && result.result.isSuccess) {
                const paymentUrl = result.result.paymentLink;
                window.location.href = paymentUrl; // Redirect user to PayU payment page
            } else {
                alert("Payment initiation failed.");
            }
        } catch (error) {
            console.error("Payment initiation error:", error);
            alert("Error initiating payment.");
        }
    };



    return (
        <>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-warning">
                                <div className="card-header">
                                    <h3 className="card-title">Order Noted</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <p className='text-grey'><b className='text-grey-bold'>Order# : </b>{data.result.orderNumber} </p>
                                                    <p><b className='text-grey-bold'>Number of Items : </b>{data.result.numberOfItems}</p>
                                                </div>
                                                <div className="col-sm-12">
                                                    <p><b className='text-grey-bold'>Remarks   : </b> {data.result.orderComments} </p>
                                                </div>
                                            </div>
                                            {
                                                data.result.orders && data.result.orders.map((item, index) => (
                                                    <>
                                                        <table className='table table-striped '>
                                                            <caption style={{ captionSide: "top" }}  ><span className='text-grey-bold'>  <b className='text-grey-bold'>Products</b></span>   <hr className='invLine'></hr></caption>

                                                            <tbody>
                                                                {
                                                                    item.orderLineItemDTOList && item.orderLineItemDTOList.map((items, index) => (
                                                                        <>
                                                                            <tr>
                                                                                <td>
                                                                                    {items.productName}
                                                                                </td>
                                                                                <td>
                                                                                    {items.totalQuantityOrdered}
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-sm-4" >

                                            <br /><br />
                                            <button className="btn btn-warning" onClick={handleInitiatePayment}>
                                                Pay Now (via PayU API)
                                            </button>
                                            <br /><br />

                                            <a href="https://api.payu.in/public/#/c85e2b89396039b750a4143618582340" class="upi-pay1">Pay Now With UPI with generated!</a>

                                            <a href="upi://pay?pa=erelatelabsprivatelimited.9284773653.ibz@icici&pn=ERelate Labs&tr=900001&am=1" class="upi-pay1">Pay Now With UPI !</a>
                                            <br /><br />
                                            <a href="upi://pay?pa=9860366327@ybl&amp;pn=Uday Kadam &amp;cu=INR" class="upi-pay1">Pay Now !</a>
                                            <br /><br />

                                            <a
                                                href="intent://pay?pa=9860366327@ybl&pn=FNAME SNAME K&mc=12524262&tid=9872533210&tr=1234667490&tn=Payment&am=1&cu=INR&url=http://juiceathome.me#Intent;scheme=upi;package=com.phonepe.app;end;"
                                                className="btn btn-success"
                                            >
                                                Pay with PhonePe
                                            </a>

                                            <br /><br />
                                            <button className="btn btn-success" onClick={handleUPIPayment1}>
                                                Pay with PhonePe 1
                                            </button>
                                            <br /><br />
                                            <button className="btn btn-success" onClick={handleUPIPayment2}>
                                                Pay with PhonePe 2
                                            </button>
                                            <br /><br />
                                            <button className="btn btn-success" onClick={handleUPIPayment3}>
                                                Pay with PhonePe 3
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default OrderTransactionDetails
